// src/pages/CourseTime/components/slides/layouts/VideoSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken, { resolveSlideTitle } from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: VideoTemplate
const VideoSlide = ({ slide, renderSpokenText, skipTitleSpeech, pageLc }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.VideoLayout>
      {resolveSlideTitle(slide) && (
        <S.SlideTitle>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>
      )}
      {slide.VideoUrl && (
        <S.VideoContainer>
          <S.VideoPlayer controls controlsList={'nodownload'} crossOrigin="anonymous">
            <source src={slide.VideoUrl} type="video/mp4" />
            {slide.VideoVttUrl && (
              <track
                kind="subtitles"
                src={slide.VideoVttUrl}
                srcLang={pageLc || 'en'}
                label={pageLc ? `Subtitles (${pageLc})` : 'Subtitles'}
                default
              />
            )}
            Your browser does not support the video tag.
          </S.VideoPlayer>
        </S.VideoContainer>
      )}
      {slide.SlideContent && (
        <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
      )}
    </S.VideoLayout>
  );
};

export default VideoSlide;
